import { useEffect, useMemo, useState } from 'react'
import { Layout, Spin } from 'antd'
import { SearchOutlined } from '@ant-design/icons'
import { useTranslation } from 'react-i18next'
import { useAppDispatch, useAppSelector } from '../../utils/redux/store'
import {
  attemptGetPlaylistsList,
  attemptGetMoodsList,
  attemptGetStylesList,
  attemptGetDaytimesList,
  attemptGetBusinessesList,
  PlaylistOrderBy,
} from '../../utils/redux/playlistSlice'
import { attemptGetFavs } from '../../utils/redux/favsSlice'
import { OrderDirection } from '../../utils/dto'
import PlaylistSection from '../../components/PlaylistSection'
import './Home.scss'
import SearchInput from '../../components/SearchInput/SearchInput'

const { Content } = Layout

export default function Home() {
  const { t } = useTranslation('home')
  const dispatch = useAppDispatch()
  const { playlistsBrief, moods, styles, daytimes, businesses } = useAppSelector(
    (state) => state.playlist,
  )

  const [activeChip, setActiveChip] = useState('energize')

  const chips = useMemo(
    () => [
      { key: 'energize', label: 'Energize' },
      { key: 'feelgood', label: 'Feel good' },
      { key: 'relax', label: 'Relax' },
      { key: 'workout', label: 'Workout' },
      { key: 'commute', label: 'Commute' },

      // повтор как на фото
      { key: 'feelgood2', label: 'Feel good' },
      { key: 'relax2', label: 'Relax' },
      { key: 'workout2', label: 'Workout' },
      { key: 'commute2', label: 'Commute' },
      { key: 'feelgood3', label: 'Feel good' },
      { key: 'relax3', label: 'Relax' },
      { key: 'workout3', label: 'Workout' },
      { key: 'commute3', label: 'Commute' },
    ],
    [],
  )

  useEffect(() => {
    const fetchData = async () => {
      await Promise.all([
        dispatch(
          attemptGetPlaylistsList({
            skip: 0,
            limit: 200,
            oderBy: PlaylistOrderBy.TITLE,
            oderDirection: OrderDirection.DESC,
          }),
        ),
        dispatch(
          attemptGetMoodsList({
            skip: 0,
            limit: 200,
            oderBy: PlaylistOrderBy.TITLE,
            oderDirection: OrderDirection.DESC,
          }),
        ),
        dispatch(
          attemptGetStylesList({
            skip: 0,
            limit: 200,
            oderBy: PlaylistOrderBy.TITLE,
            oderDirection: OrderDirection.DESC,
          }),
        ),
        dispatch(
          attemptGetDaytimesList({
            skip: 0,
            limit: 200,
            oderBy: PlaylistOrderBy.TITLE,
            oderDirection: OrderDirection.DESC,
          }),
        ),
        dispatch(
          attemptGetBusinessesList({
            skip: 0,
            limit: 200,
            oderBy: PlaylistOrderBy.TITLE,
            oderDirection: OrderDirection.DESC,
          }),
        ),
        dispatch(attemptGetFavs()),
      ])
    }
    fetchData()
  }, [dispatch])

  if (!playlistsBrief && !moods && !styles && !daytimes && !businesses) {
    return (
      <div className="home-loading">
        <Spin size="large" />
      </div>
    )
  }

  return (
    <Content style={{ paddingBottom: '200px' }} className="home-content">
      <div className="home-container">
        {/* HEADER 1в1 как на фото */}
        <div className="home-topbar">
          <div className="home-topbar__row">
            <SearchInput />

            <div className="home-stats">
              219 songs <span className="home-stats__sep">|</span> 14 hours{' '}
              <span className="home-stats__sep">|</span> 4,432 playlists
            </div>
          </div>

          <div className="home-chips">
            {chips.map((c) => (
              <button
                key={c.key}
                type="button"
                className={`home-chip ${activeChip === c.key ? 'is-active' : ''}`}
                onClick={() => setActiveChip(c.key)}
              >
                {c.label}
              </button>
            ))}
          </div>
        </div>

        {/* НИЖЕ — ТВОИ СЕКЦИИ */}
        {playlistsBrief && playlistsBrief.length > 0 && (
          <PlaylistSection
            title={t('playlists')}
            items={playlistsBrief}
            type="playlist"
          />
        )}

        {moods && moods.length > 0 && (
          <PlaylistSection title={t('moods')} items={moods} type="mood" />
        )}

        {styles && styles.length > 0 && (
          <PlaylistSection title={t('styles')} items={styles} type="style" />
        )}

        {daytimes && daytimes.length > 0 && (
          <PlaylistSection title={t('daytimes')} items={daytimes} type="daytime" />
        )}

        {businesses && businesses.length > 0 && (
          <PlaylistSection title={t('businesses')} items={businesses} type="business" />
        )}
      </div>
    </Content>
  )
}
